import { OutlinedBadge } from "lib/@components/outlined-badge"
import { NavCountBadge } from "lib/@components/nav-count-badge"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_SIDE_NAV_REDESIGN } from "routes/@layouts/app/navbar/feature-flag-side-nav-redesign.runtime"

export function NavBadge({ count, label, color }) {
    if (isEnabled(FEATURE_FLAG_SIDE_NAV_REDESIGN)) return <NavCountBadge count={count} label={label} />
    return <OutlinedBadge content={count} color={color} />
}
